import { BRAND } from "../constants/brand";
import PageHero from "../components/PageHero";

const PORTALS = [
  {
    title: "Provider / Employee Portal",
    subtitle: "NetSmart Cloud — LIS & Supply Ordering",
    desc: "Access the Labarium Laboratory Information System (LIS) for order entry, result review, supply ordering, and account management.",
    href: "https://mllaborchard.netsmartcloud.com/",
    btnLabel: "ACCESS PROVIDER PORTAL →",
    color: BRAND.navy,
    features: ["Order entry & tracking", "Result review", "Supply ordering", "Account management", "EMR integration support"],
  },
  // {
  //   title: "Patient Results Portal",
  //   subtitle: "DXLink — Secure Patient Access",
  //   desc: "View your laboratory test results securely online. Available 24/7. You'll receive an activation email from your provider after your first visit.",
  //   href: "https://www.dxlink.com/patientportal/signin.html?cn=medlake&tn=medlake#/login",
  //   btnLabel: "ACCESS PATIENT PORTAL →",
  //   color: "#0a4a9e",
  //   features: ["View test results 24/7", "Download result reports", "Secure HIPAA-compliant access", "View historical results"],
  // },
  // {
  //   title: "Pay Online",
  //   subtitle: "Xifin — Patient Payment Portal",
  //   desc: "Pay your Labarium bill securely online. Use this portal for invoices dated after January 1, 2023.",
  //   href: "https://patient.xifin.net/peportal/pages/login/?cn=medlake&tn=medlake#/login",
  //   btnLabel: "PAY YOUR BILL →",
  //   color: BRAND.navyDark,
  //   features: ["Secure online payment", "View current balance", "Payment history", "Download statements"],
  // },
];

export default function PortalAccessPage() {
  return (
    <>
      <PageHero eyebrow="PROVIDERS" title="Portal" highlight="Access" subtitle="Secure online access to all Labarium platforms — for providers, patients, and billing." />

      <div className="rx-pad" style={{ background: BRAND.offWhite, padding: "72px 32px 96px" }}>
        <div style={{ maxWidth: 1280, margin: "0 auto" }}>
          <div style={{ display: "flex", justifyContent: "center" }}>
          <div style={{ width: "100%", maxWidth: 520 }}>
            {PORTALS.map(portal => (
              <div key={portal.title} style={{ background: BRAND.white, borderRadius: 16, border: `1px solid ${BRAND.lightGray}`, overflow: "hidden", boxShadow: "0 4px 20px rgba(0,53,122,0.06)" }}>
                <div style={{ background: portal.color, padding: "28px 32px", position: "relative" }}>
                  <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 3, background: BRAND.gold }} />
                  <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: 10, fontWeight: 700, letterSpacing: "0.2em", color: BRAND.gold, marginBottom: 8 }}>{portal.subtitle.toUpperCase()}</div>
                  <h3 style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: 24, color: BRAND.white, margin: 0 }}>{portal.title}</h3>
                </div>
                <div style={{ padding: "28px 32px" }}>
                  <p style={{ fontFamily: "'Barlow', sans-serif", fontSize: 13, color: BRAND.textMid, lineHeight: 1.8, marginBottom: 24 }}>{portal.desc}</p>
                  <div style={{ marginBottom: 28 }}>
                    {portal.features.map(f => (
                      <div key={f} style={{ display: "flex", gap: 10, marginBottom: 8, alignItems: "center" }}>
                        <div style={{ width: 6, height: 6, borderRadius: "50%", background: BRAND.gold, flexShrink: 0 }} />
                        <span style={{ fontFamily: "'Barlow', sans-serif", fontSize: 13, color: BRAND.textMid }}>{f}</span>
                      </div>
                    ))}
                  </div>
                  <a href={portal.href} target="_blank" rel="noreferrer" style={{ display: "block", textDecoration: "none", textAlign: "center", background: portal.color, color: BRAND.white, fontFamily: "'Barlow', sans-serif", fontWeight: 700, fontSize: 12, letterSpacing: "0.1em", padding: "14px 20px", borderRadius: 10 }}>
                    {portal.btnLabel}
                  </a>
                </div>
              </div>
            ))}
          </div>
          </div>

          <div style={{ marginTop: 48, background: BRAND.white, borderRadius: 16, padding: "36px 40px", border: `1px solid ${BRAND.lightGray}`, boxShadow: "0 4px 20px rgba(0,53,122,0.06)" }}>
            <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: 11, fontWeight: 700, letterSpacing: "0.22em", color: BRAND.gold, marginBottom: 12 }}>NEED HELP WITH PORTAL ACCESS?</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 32, alignItems: "center", flexWrap: "wrap" }}>
              <p style={{ fontFamily: "'Barlow', sans-serif", fontSize: 14, color: BRAND.textMid, lineHeight: 1.8, margin: 0 }}>
                If you're having trouble accessing any of our portals, contact our customer service team. For new providers interested in EMR integration or portal setup, our technical support team can assist with onboarding.
              </p>
              <div style={{ flexShrink: 0 }}>
                <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: 10, fontWeight: 700, letterSpacing: "0.18em", color: BRAND.gold, marginBottom: 3 }}>TOLL-FREE</div>
                <div style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: 22, color: BRAND.navy, marginBottom: 2 }}>(877) 765-2274</div>
                <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: 10, fontWeight: 700, letterSpacing: "0.18em", color: BRAND.gold, margin: "8px 0 3px" }}>DIRECT</div>
                <div style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: 18, color: BRAND.navy, marginBottom: 4 }}>(850) 460-1484</div>
                <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: 12, color: BRAND.textMid }}>Mon–Fri · 8:00AM–5:30PM</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
